/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
// import * as wjCore from "@grapecity/wijmo"
// import * as wjGrid from "@grapecity/wijmo.grid"
// import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
// import queryString from "query-string"
import * as wjrInput from "@grapecity/wijmo.react.input"
import * as wjCore from "@grapecity/wijmo"
import * as wjcInput from "@grapecity/wijmo.input"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import { showInfoToast } from "../../../components/CustomToast"
import TextInput from "../../../components/InputWrapper/TextInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import CONSTANT from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import ZyomuinKyuyoMasterService from "../../../service/driverpayroll/zyomuinKyuyoMaster/zyomuinKyuyoMasterService"

import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"
import {
  TZyomuinKyuyoMasterGetRes,
  TZyomuinKyuyoMasterRegisterPostReq,
  TZyomuinKyuyoMasterRegisterPutReq,
} from "../../../service/driverpayroll/zyomuinKyuyoMaster/TZyomuinKyuyoMaster"
import dayjs from "dayjs"
import { RootState } from "../../../globalStore/rootreducer"
import React from "react"
import dateUtil from "../../../ts/util/dateUtil"

/**
 * 乗務員給与マスタ 登録
 * @returns
 */
const ZyomuinKyuyoMasterRegister = () => {
  const history = useHistory()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  const disPatch: AppDispatch = useDispatch()

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region [state]

  // ID
  const [乗務員給与ID, set乗務員給与ID] = useState<number>()
  // 表示項目のstate
  const [部所名, set部所名] = useState<string>("")
  const [社員コード, set社員コード] = useState<string>("")
  const [社員氏名, set社員氏名] = useState<string>("")
  const [年齢, set年齢] = useState<string>("")
  const [在籍年数, set在籍年数] = useState<string>("")

  const [基本給, set基本給] = useState<number>()
  const [時間外単価, set時間外単価] = useState<number>()
  const [深夜残単価, set深夜残単価] = useState<number>()
  const [日曜残単価, set日曜残単価] = useState<number>()
  const [休日手当, set休日手当] = useState<number>()
  const [通勤費, set通勤費] = useState<number>()
  const [通勤費税込, set通勤費税込] = useState<number>()
  const [評価割増, set評価割増] = useState<number>()
  const [住宅手当, set住宅手当] = useState<number>()
  const [能力開発, set能力開発] = useState<number>()
  const [業務手当, set業務手当] = useState<number>()
  const [地域最低賃金, set地域最低賃金] = useState<number>()
  const [その他手当, setその他手当] = useState<number>()

  const [最終更新日時, set最終更新日時] = useState<string>()
  const [最終更新ID, set最終更新ID] = useState<string>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  //#endregion

  //#region [method]
  /**
   * 検索
   */
  const search = async (id: number) => {
    dispatch(clearAlert()) // アラートを非表示に

    try {
      const service = new ZyomuinKyuyoMasterService()

      const res = (await service.get(
        id
      )) as TApiResponse<TZyomuinKyuyoMasterGetRes>

      if (res.data) {
        // 乗務員給与ID
        if (res.data.乗務員給与ID) {
          set乗務員給与ID(res.data.乗務員給与ID)
        }
        set部所名(res.data.部所名)
        set社員コード(res.data.社員コード)
        set社員氏名(res.data.社員氏名)
        // 年齢
        if (
          res.data.生年月日 != null &&
          !wjCore.isNullOrWhiteSpace(res.data.生年月日)
        ) {
          const today = dayjs(eigyobi)
          set年齢(today.diff(res.data.生年月日, "year").toString())
        }
        // 在籍年数
        const 在籍年月数Str = dateUtil.to在籍年月数Str(
          eigyobi,
          res.data.入社年月日,
          res.data.退職年月日
        )
        set在籍年数(在籍年月数Str)

        set基本給(res.data.基本給)
        set時間外単価(res.data.時間外単価)
        set深夜残単価(res.data.深夜残単価)
        set日曜残単価(res.data.日曜残単価)
        set休日手当(res.data.休日手当)
        set通勤費(res.data.通勤費_非課税)
        set通勤費税込(res.data.通勤費_課税)
        set評価割増(res.data.評価割増)
        set住宅手当(res.data.住宅手当)
        set能力開発(res.data.能力開発)
        set業務手当(res.data.業務手当)
        // TODO: KIROS_DEV-293 乗務員給与マスタの変更 地域最低賃金の項目削除をテーブル削除時にやるため、そのままとする
        set地域最低賃金(res.data.地域調整用最低賃金)
        setその他手当(res.data.その他手当)
        set最終更新日時(res.data.更新日時)
        set最終更新ID(
          res.data.更新ユーザID ? res.data.更新ユーザID.toString() : ""
        )
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
    }
  }

  /**
   * 更新アイテム生成
   */
  const createPutZyomuinKyuyo = (): TZyomuinKyuyoMasterRegisterPutReq => {
    return {
      乗務員給与ID,
      乗務員ID: id!,
      基本給: 基本給 ?? 0,
      時間外単価: 時間外単価 ?? 0,
      深夜残単価: 深夜残単価 ?? 0,
      日曜残単価: 日曜残単価 ?? 0,
      休日手当: 休日手当 ?? 0,
      通勤費_非課税: 通勤費 ?? 0,
      通勤費_課税: 通勤費税込 ?? 0,
      評価割増: 評価割増 ?? 0,
      住宅手当: 住宅手当 ?? 0,
      能力開発: 能力開発 ?? 0,
      業務手当: 業務手当 ?? 0,
      // TODO: KIROS_DEV-293 乗務員給与マスタの変更 地域最低賃金の項目削除をテーブル削除時にやるため、そのままとする
      地域調整用最低賃金: 地域最低賃金 ?? 0,
      その他手当: その他手当 ?? 0,
      更新日時: 最終更新日時 ? 最終更新日時.toString() : "",
    }
  }

  /**
   * 登録アイテム生成
   */
  const createPostZyomuinKyuyo = (): TZyomuinKyuyoMasterRegisterPostReq => {
    return {
      乗務員ID: id!,
      基本給: 基本給 ?? 0,
      時間外単価: 時間外単価 ?? 0,
      深夜残単価: 深夜残単価 ?? 0,
      日曜残単価: 日曜残単価 ?? 0,
      休日手当: 休日手当 ?? 0,
      通勤費_非課税: 通勤費 ?? 0,
      通勤費_課税: 通勤費税込 ?? 0,
      評価割増: 評価割増 ?? 0,
      住宅手当: 住宅手当 ?? 0,
      能力開発: 能力開発 ?? 0,
      業務手当: 業務手当 ?? 0,
      // TODO: KIROS_DEV-293 乗務員給与マスタの変更 地域最低賃金の項目削除をテーブル削除時にやるため、そのままとする
      地域調整用最低賃金: 地域最低賃金 ?? 0,
      その他手当: その他手当 ?? 0,
      更新日時: 最終更新日時 ? 最終更新日時.toString() : "",
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装

    setIsConfirmModalShow(true)
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      if (id == null) return

      if (
        基本給 == null ||
        時間外単価 == null ||
        深夜残単価 == null ||
        日曜残単価 == null ||
        休日手当 == null ||
        通勤費 == null ||
        通勤費税込 == null ||
        評価割増 == null ||
        住宅手当 == null ||
        能力開発 == null ||
        業務手当 == null ||
        // TODO: KIROS_DEV-293 乗務員給与マスタの変更 地域最低賃金の項目削除をテーブル削除時にやるため、そのままとする
        地域最低賃金 == null ||
        その他手当 == null
      )
        // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認
        return

      const service = new ZyomuinKyuyoMasterService()
      let res: TApiResponse<boolean>

      // 乗務員が持ってる給与IDの有無で処理分岐
      if (乗務員給与ID) {
        res = await service.put(id, createPutZyomuinKyuyo())
      } else {
        res = await service.post(id, createPostZyomuinKyuyo())
      }

      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`乗務員給与の更新が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())
    if (id) {
      search(id).finally(() => {
        disPatch(画面ロック解除())
      })
      // ファイルロード後、戻るボタン押下時に警告が出るように変更
      isPrompt.current = true
    }
  }, [])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">
              乗務員給与マスタ {乗務員給与ID ? "更新" : "登録"}
            </span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-70rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 所属部所 */}
                  <MasterRegisterFormRow label="所属部所" isRequired={false}>
                    <div className="w-6rem">
                      <TextInput
                        id="所属部所"
                        name="所属部所"
                        value={部所名}
                        setValue={(v) => {
                          set部所名(v)
                        }}
                        isReadOnly
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 社員 */}
                  <MasterRegisterFormRow label="社員コード" isRequired={false}>
                    <div className="w-6rem">
                      <TextInput
                        id="社員コード"
                        name="社員コード"
                        value={社員コード}
                        setValue={(v) => {
                          set社員コード(v)
                        }}
                        isReadOnly
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 社員氏名 */}
                  <MasterRegisterFormRow
                    label="氏名（漢字）"
                    isRequired={false}>
                    <div className="w-15rem">
                      <TextInput
                        id="社員氏名"
                        name="社員氏名"
                        value={社員氏名}
                        setValue={(v) => {
                          set社員氏名(v)
                        }}
                        isReadOnly
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 年齢 */}
                  <MasterRegisterFormRow label="年齢" isRequired={false}>
                    <div className="w-6rem">
                      <TextInput
                        id="年齢"
                        name="年齢"
                        value={年齢}
                        setValue={(v) => {
                          set年齢(v)
                        }}
                        isReadOnly
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 在籍年数 */}
                  <MasterRegisterFormRow label="在籍年数" isRequired={false}>
                    <div className="w-6rem">
                      <TextInput
                        id="在籍年数"
                        name="在籍年数"
                        value={在籍年数}
                        setValue={(v) => {
                          set在籍年数(v)
                        }}
                        isReadOnly
                      />
                    </div>
                  </MasterRegisterFormRow>
                  <br></br>
                  {/* TODO:NumberInputの制御問題 */}
                  {/* 基本給 */}
                  <MasterRegisterFormRow label="基本給" isRequired={true}>
                    <wjrInput.InputNumber
                      initialized={(control: wjcInput.InputNumber) => {
                        control.inputElement?.focus()
                      }}
                      style={{ width: "8rem" }}
                      id="基本給"
                      name="基本給"
                      format={"N0"}
                      focus
                      isRequired={true}
                      value={基本給}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set基本給(c.value)
                          : set基本給(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 時間外単価 */}
                  <MasterRegisterFormRow label="時間外単価" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="時間外単価"
                      name="時間外単価"
                      format={"N0"}
                      isRequired={true}
                      value={時間外単価}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set時間外単価(c.value)
                          : set時間外単価(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 深夜残単価 */}
                  <MasterRegisterFormRow label="深夜残単価" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="深夜残単価"
                      name="深夜残単価"
                      format={"N0"}
                      isRequired={true}
                      value={深夜残単価}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set深夜残単価(c.value)
                          : set深夜残単価(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 日曜残単価 */}
                  <MasterRegisterFormRow label="日曜残単価" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="日曜残単価"
                      name="日曜残単価"
                      format={"N0"}
                      isRequired={true}
                      value={日曜残単価}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set日曜残単価(c.value)
                          : set日曜残単価(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 休日手当 */}
                  <MasterRegisterFormRow label="休日手当" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="休日手当"
                      name="休日手当"
                      format={"N0"}
                      isRequired={true}
                      value={休日手当}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set休日手当(c.value)
                          : set休日手当(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 通勤費 */}
                  <MasterRegisterFormRow label="通勤費" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="通勤費"
                      name="通勤費"
                      format={"N0"}
                      isRequired={true}
                      value={通勤費}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set通勤費(c.value)
                          : set通勤費(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 通勤費税込 */}
                  <MasterRegisterFormRow label="通勤費税込" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="通勤費税込"
                      name="通勤費税込"
                      format={"N0"}
                      isRequired={true}
                      value={通勤費税込}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set通勤費税込(c.value)
                          : set通勤費税込(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 評価割増 */}
                  <MasterRegisterFormRow label="評価割増" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="評価割増"
                      name="評価割増"
                      format={"N0"}
                      isRequired={true}
                      value={評価割増}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set評価割増(c.value)
                          : set評価割増(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 住宅手当 */}
                  <MasterRegisterFormRow label="住宅手当" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="住宅手当"
                      name="住宅手当"
                      format={"N0"}
                      isRequired={true}
                      value={住宅手当}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set住宅手当(c.value)
                          : set住宅手当(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 能力開発 */}
                  <MasterRegisterFormRow label="能力開発" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="能力開発"
                      name="能力開発"
                      format={"N0"}
                      isRequired={true}
                      value={能力開発}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set能力開発(c.value)
                          : set能力開発(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 業務手当 */}

                  <MasterRegisterFormRow label="業務手当" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="業務手当"
                      name="業務手当"
                      format={"N0"}
                      isRequired={true}
                      value={業務手当}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set業務手当(c.value)
                          : set業務手当(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 地域最低賃金 */}
                  {/* 項目として不要となったため削除 */}
                  {/* その他手当 */}
                  <MasterRegisterFormRow label="その他手当" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="その他手当"
                      name="その他手当"
                      format={"N0"}
                      isRequired={true}
                      value={その他手当}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? setその他手当(c.value)
                          : setその他手当(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {乗務員給与ID && (
          <>
            <Row>
              <Col>
                最終更新日時:
                {util.date.format(最終更新日時, "YYYY/MM/DD HH:mm:ss")}
              </Col>
            </Row>
            <Row>
              <Col>最終更新ID : {最終更新ID}</Col>
            </Row>
          </>
        )}
        <Row className="search-button">
          <Col xl={{ span: "auto", offset: 0 }}>
            <Button
              type="submit"
              variant="waiting"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                beforeSubmit()
              }}>
              {乗務員給与ID ? `更新` : `登録`}
            </Button>
          </Col>
          <Col>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{乗務員給与ID ? "更新" : "登録"}しますか？
      </ConfirmModal>
    </>
  )
}

export default ZyomuinKyuyoMasterRegister
